import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Row, Col, Affix, Button, Skeleton, Modal } from "antd";
import {
  getExecutorById,
  createExecutor,
  updateExecutor,
  deleteExecutor,
  restoreArchiveExecutor
} from "../../redux/actions/executorCard";
import { interfaceActions } from "../../../../common/redux/actions";
import FormExecutorCard from "../../components/ExecutorCard/FormExecutorCard";
import FormProgress from "../../components/FormProgress/FormProgress";
import BtnCloseEditing from "../../components/ExecutorCard/buttons/BtnCloseEditing";
import BtnFormSubmit from "../../components/ExecutorCard/buttons/BtnFormSubmit";
import history from "../../../../common/history";
import progresses from "../../components/FormProgress/progresses";
import {
  confirmDelete,
  confirmRestoreArchive
} from "../../components/ExecutorCard/popup/confirm";
import * as URLs from "../../../../common/constants/systemUrls";
const { setCaption } = interfaceActions;
const confirm = Modal.confirm;

class ExecutorCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditable: false,
      formProgress: [...progresses.default],
      executorId: this.getExecutorId(),
      disabledSaveButton: true
    };
    if (this.state.executorId === 0) {
      this.state.isEditable = true;
    }
    this.forms = {};
  }
  componentDidMount() {
    this.setCaption(true);
    if (this.state.executorId > 0) {
      this.props.getExecutorById(this.state.executorId);
    }
  }

  componentDidUpdate(prevProps, _prevState) {
    this.updateExecutorId(); // Смотрим не сменился ли executorId
    this.setCaption(this.props.data !== prevProps.data && this.props.data);
  }

  setCaption(flagUpdate = false) {
    if (flagUpdate) {
      let title = "";
      let breadCrumbs = null;
      if (this.state.executorId === 0) {
        title = "Добавление исполнителя";
      } else {
        const { data } = this.props;
        if (data) {
          title = data.companyName;
          if (this.state.isEditable) {
            breadCrumbs = title;
            title = "Редактирование исполнителя";
          }
        }
      }

      if (title) {
        this.props.setCaption({
          enabled: true,
          mainCaption: title,
          breadCrumbs: [
            {
              path: "/" + URLs.CONTROL_PANEL,
              breadcrumbName: "Панель управления"
            },
            {
              path: "/" + URLs.SYSTEM_SETTINGS + "/executors",
              breadcrumbName: "Настройки системы - Мои исполнители"
            },
            {
              path: "/" + URLs.COMPANY,
              breadcrumbName: breadCrumbs ? breadCrumbs : title
            }
          ]
        });
      }
    }
  }

  updateExecutorId() {
    const executorId = this.getExecutorId();
    if (executorId !== this.state.executorId) {
      if (executorId > 0) {
        this.props.getExecutorById(executorId);
      }
      this.setState(state => ({
        executorId,
        isEditable: executorId === 0 ? true : state.isEditable
      }));
    }
  }

  deleteExecutor = () => {
    const { executorId } = this.state;
    confirm({
      ...confirmDelete,
      onOk: () => {
        this.props.deleteExecutor(executorId);
      }
    });
  };

  restoreArchiveExecutor = () => {
    const { executorId } = this.state;
    confirm({
      ...confirmRestoreArchive,
      onOk: () => {
        this.props.restoreArchiveExecutor(executorId);
      }
    });
  };

  handleClickClose = () => {
    if (this.state.executorId > 0) {
      this.setState({ isEditable: false });
    } else {
      history.push("/" + URLs.SYSTEM_SETTINGS + "/executors");
    }
  };

  handleSubmit = () => {
    this.formSubmit("formExecutorCard", fieldsValue => {
      const { executorId } = this.state;
      let data = {
        executorId,
        ...fieldsValue
      };
      if (executorId === 0) {
        this.props.createExecutor(data);
      } else {
        this.props.updateExecutor(data);
      }
    });
  };

  /* todo то что можно вынести в общие компоненты */
  formSubmit = (name, cbSubmit) => {
    const form = this.getForm(name);
    if (form) {
      // e.preventDefault();
      form.validateFields((err, fieldsValue) => {
        if (err) {
          return false;
        }
        // Отправка формы
        if (cbSubmit) cbSubmit(fieldsValue);
      });
    } else {
      console.log("Error", name);
    }
  };

  getExecutorId() {
    let { id = 0 } = this.props.match && this.props.match.params;
    id = Number(id);
    return id > 0 ? id : 0;
  }

  getForm = name => {
    if (this.forms.hasOwnProperty(name)) {
      return this.forms[name];
    }
    return false;
  };

  setForm = (name, form) => {
    if (form) {
      return (this.forms[name] = form);
    } else {
      delete this.forms[name];
      return false;
    }
  };
  // Обновление прогресса заполнения
  updateProgress = values => {
    const form = this.getForm("formExecutorCard");
    if (form) {
      let newFormProgress = null;
      let checkAll = true;
      Object.keys(values).forEach(name => {
        this.state.formProgress.forEach((step, index) => {
          if (step.fields.some(fieldName => fieldName === name) && step.check) {
            const fieldsValue = form.getFieldsValue(step.fields);
            const check = step.check(fieldsValue, form);
            if (!newFormProgress)
              newFormProgress = [...this.state.formProgress];
            newFormProgress = [
              ...newFormProgress.slice(0, index),
              {
                ...newFormProgress[index],
                name: step.name,
                completed: check,
                fieldsValue: fieldsValue
              },
              ...newFormProgress.slice(index + 1)
            ];
            if (checkAll && !check) {
              if (step.button !== false) checkAll = false;
            }
          }
        });
      });

      if (newFormProgress) {
        if (checkAll) {
          // Если все изменённые поля успешно прошли проверку
          // делаем полную проверку по всем группам
          // если button = false тогда он не участвует в проверке для кнопки отправки.
          // если в прогрессе нет ключа button то по умолчанию он равен true
          checkAll = newFormProgress.every(({ completed, button = true }) =>
            button ? completed : true
          );
        }
        this.setState({
          formProgress: newFormProgress,
          disabledSaveButton: !checkAll
        });
      }
    }
  };

  handleClickEdit = () => {
    this.setState(
      state => ({
        isEditable: true
      }),
      () => {
        this.setCaption(true);
      }
    );
  };

  render() {
    const { isEditable } = this.state;
    const { data, isLoading } = this.props;
    const typeForm =
      this.state.executorId > 0 ? (isEditable ? "edit" : "view") : "create";
    return (
      <div className="basicForm">
        <Row>
          <Col span={18} className="offer-card__form" style={{marginBottom: 66}}>
            {isLoading ? (
              <Skeleton active />
            ) : (
              <FormExecutorCard
                name="formExecutorCard"
                setForm={this.setForm}
                data={data}
                executorId={this.state.executorId}
                // createErrors={createErrors}
                // clearError={clearError}
                updateProgress={this.updateProgress}
                isEditable={this.state.isEditable}
                formProgress={this.state.formProgress}
                typeForm={typeForm}
                dadataBankSelected={this.props.dadataBankSelected}
              />
            )}
          </Col>
          <Col span={6} className="offer-card__status order-card__sidebar">
            <Affix
              offsetTop={18}
              target={() => document.getElementById("mainSheet")}
            >
              <React.Fragment>
                {typeForm === "view" ? (
                  <Fragment>
                    {data && !data.archive && (
                      <Fragment>
                        <Button
                          type="primary"
                          htmlType="submit"
                          size="large"
                          className="offers-create__submit"
                          onClick={this.handleClickEdit}
                        >
                          Редактировать
                        </Button>
                        <Button
                          type="primary"
                          htmlType="submit"
                          size="large"
                          className="offers-create__submit"
                          ghost
                          style={{
                            color: "#f5222d",
                            backgroundColor: "#ffffff",
                            borderColor: "#f5222d"
                          }}
                          onClick={this.deleteExecutor}
                        >
                          Архивировать
                        </Button>
                      </Fragment>
                    )}
                    {data && data.archive && (
                      <Fragment>
                        <Button
                          type="primary"
                          htmlType="submit"
                          size="large"
                          className="offers-create__submit"
                          onClick={this.restoreArchiveExecutor}
                        >
                          Восстановить
                        </Button>
                      </Fragment>
                    )}
                    <Button
                      ghost
                      type="danger"
                      htmlType="submit"
                      size="large"
                      className="offers-create__submit"
                      style={{
                        color: "#f5222d",
                        backgroundColor: "#ffffff",
                        borderColor: "#f5222d"
                      }}
                      onClick={() => this.props.history.goBack()}
                    >
                      Назад
                    </Button>
                  </Fragment>
                ) : (
                  <Fragment>
                    <BtnFormSubmit
                      disabled={this.state.disabledSaveButton}
                      onClick={this.handleSubmit}
                      typeForm={typeForm}
                    />
                    <FormProgress progress={this.state.formProgress} />
                    <BtnCloseEditing handleClick={this.handleClickClose} />
                  </Fragment>
                )}
              </React.Fragment>
            </Affix>
          </Col>
        </Row>
      </div>
    );
  }
}
export default connect(
  state => ({
    data: state.Executors.ExecutorCard.executorData,
    isLoading: state.Executors.ExecutorCard.isLoading,
    dadataBankSelected: state.Customers.dadataBank.selected,
  }),
  {
    getExecutorById,
    createExecutor,
    updateExecutor,
    deleteExecutor, // todo заменить название на архив
    restoreArchiveExecutor,
    setCaption
  }
)(ExecutorCard);
